












import Vue from 'vue';
import MainNav from '@/components/MainNav.vue';
import GoogleMap from '@/components/GoogleMap.vue';

export default Vue.extend({
  components: {
    MainNav,
    GoogleMap,
  },

  data() {
    return {
      loaded: false,
    };
  },

  computed: {
    loading(): boolean {
      return !this.loaded;
    },
  },

  methods: {
    onMapFrameLoaded(): void {
      this.loaded = true;
    },
  },
});
